import Vue from 'vue'
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue'
import VueLazyLoad from 'vue-lazyload'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-image-lightbox/dist/vue-image-lightbox.min.css'
import Notifications from 'vue-notification'
import i18n from './i18n'
import Clipboard from 'v-clipboard'

Vue.use(BootstrapVue)
Vue.use(VueLazyLoad)
Vue.use(Notifications)
Vue.use(Clipboard)

Vue.config.productionTip = false

new Vue({
  i18n,
  render: h => h(App)
}).$mount('#app')
